import React from 'react'
import Icon from 'components/Shared/Icon'
import ProgressBar from 'components/Shared/ProgressBar'

const LoadingMessage: React.FC<{ progress: number }> = ({ progress }) => (
  <div className="audit-loading">
    <div className="audit-loading-content">
      <ProgressBar position={progress} />
      <h3>Analyzing Your App</h3>
      <div className="audit-loading-steps">
        <p>
          <Icon type="check" /> Scanning app structure...
        </p>
        <p>
          <Icon type="search" /> Analyzing component complexity...
        </p>
        <p>
          <Icon type="link" /> Checking navigation patterns...
        </p>
        <p>
          <Icon type="warning" /> Identifying potential issues...
        </p>
      </div>
    </div>
  </div>
)

export default React.memo(LoadingMessage)
